/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 0.0.1
 */

/**
 * Category of test
 */
export type CreateDiagnosticProcedureDtoCategoryOfTest =
  (typeof CreateDiagnosticProcedureDtoCategoryOfTest)[keyof typeof CreateDiagnosticProcedureDtoCategoryOfTest];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateDiagnosticProcedureDtoCategoryOfTest = {
  direct: 'direct',
  indirect: 'indirect',
  observation: 'observation',
  others: 'others',
} as const;
